var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-overview-container" },
    [
      _c("AutomationWizardOverviewDescription", {
        staticClass: "automation-wizard-overview-container__description",
        attrs: { template: _vm.template }
      }),
      _vm._v(" "),
      _c("AutomationWizardOverviewScenario", {
        staticClass: "automation-wizard-overview-container__scenario",
        attrs: { scenario: _vm.scenario }
      }),
      _vm._v(" "),
      !_vm.isEditMode
        ? _c("AutomationWizardOverviewBenefits", {
            attrs: { benefits: _vm.benefits }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }